import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../Store/Auth/AuthSelector";

export type Role = "super_admin" | "company_admin" | "content_manager";

interface RoleGateProps {
  allow: Role[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Render children only when the logged-in user's role is in `allow`.
 * Falls back to `fallback` (or null) otherwise. Pair with backend Policies
 * so the UI matches what the API allows.
 */
const RoleGate: React.FC<RoleGateProps> = ({ allow, children, fallback = null }) => {
  const user = useSelector(selectCurrentUser);
  if (!user || !allow.includes(user.role as Role)) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
};

export default RoleGate;
